export const tableStyling = {
  headRow: {
    style: {
      backgroundColor: "#092C4C", // Bootstrap primary color
      color: "#fff",
      fontWeight: "bold",
      fontSize: "15px",
    },
  },
  headCells: {
    style: {
      color: "#fff",
      fontWeight: "600",
    },
  },
};

export const customTableStyles = {
  table: {
    style: {
      border: "1px solid #dee2e6",
      borderRadius: "6px",
      overflow: "hidden",
      backgroundColor: "#fff"
    }
  },

  headRow: {
    style: {
      backgroundColor: "#e74a4aff", // Bootstrap primary
      minHeight: "56px"
    }
  },

  headCells: {
    style: {
      color: "#ffffff",
      fontSize: "14px",
      fontWeight: "600",
      padding: "14px 16px",
      textTransform: "capitalize"
    }
  },

  rows: {
    style: {
      minHeight: "48px",
      fontSize: "13.5px",
      color: "#212529",
      borderBottom: "1px solid #dee2e6"
    }
  },

  cells: {
    style: {
      padding: "12px 16px"
    }
  },

  stripedStyle: {
    backgroundColor: "#f8f9fa" // Bootstrap striped
  },

  highlightOnHoverStyle: {
    backgroundColor: "#e9ecef"
  }
};
